import React, { ReactElement, ReactNode } from 'react';

import config from 'config';
import Organization from 'entities/organization/model';

export default ({
  organization,
  children = <>You can direct donors to your nonprofit donation page by following this link: </>,
}: {
  organization: Organization;
  children?: ReactNode;
}): ReactElement => (
  <>
    {children}
    {/* eslint-disable-next-line react/jsx-no-target-blank */}
    <a target="_blank" href={`${config.clientUrl}/organization/${organization.id}/donate`}>
      {config.clientUrl}
      /organization/
      {organization.id}
      /donate
    </a>
  </>
);
